import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();

  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Aucun patient trouvé
        </h3>
        <p className="text-sm text-muted-foreground text-center mb-6 max-w-md">
          Aucun patient ne correspond aux critères de recherche actuels. Essayez de modifier vos filtres.
        </p>
        <Button
          variant="outline"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          Effacer les filtres
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
        <Icon name="Users" size={32} className="text-primary" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        Aucun patient enregistré
      </h3>
      <p className="text-sm text-muted-foreground text-center mb-6 max-w-md">
        Commencez par créer votre premier dossier patient pour gérer les cas orthodontiques.
      </p>
       
       
    </div>
  );
};

export default EmptyState;